import { render, staticRenderFns } from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=template&id=0b6e420c&scoped=true"
import script from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=script&lang=js"
export * from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=script&lang=js"
import style0 from "./ddo-asset-group-category-asset-group-criticality-view.vue?vue&type=style&index=0&id=0b6e420c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e420c",
  null
  
)

export default component.exports